import DefaultButton from '@src/components/ui-kit/buttons/DefaultButton';
import { Button, Row } from 'antd';
import styles from './audio-side-drawer.module.css';

function displayAudioName(name: string) {
  const regex = new RegExp('_', 'g');
  return name.replace(regex, ' ').toUpperCase();
}

export function AudioSideDrawer({ callback, audios }) {
  return (
    <>
      {audios.map((audio, i) => (
        <Row
          key={`${audio.name}-${i}`}
          className={`${styles.containerAudioPlayer}`}
        >
          <p>{displayAudioName(audio.name)}</p>
          <audio src={audio.url} controls></audio>
          <DefaultButton
            type='secondary'
            style={{ minHeight: 32 }}
            onClick={() => {
              callback(audio.url, audio.name);
            }}
          >
            <span style={{ color: '#333333' }}>Add to scene</span>
          </DefaultButton>
        </Row>
      ))}
    </>
  );
}
